import {
  MyHistoryCreditResponseDto
} from '@features/credit/application/use_cases/my-history-credit/dto/my-history-credit.response.dto';
import {
  MyHistoryCreditPayloadDto
} from '@features/credit/application/use_cases/my-history-credit/dto/my-history-credit.payload.dto';

import {
  MyHistoryCreditHttpResponseDto
} from '@features/credit/infrastructure/http/my-history-credit/my-history-credit.http.response.dto';
import {
  MyHistoryCreditHttpPayloadDto
} from '@features/credit/infrastructure/http/my-history-credit/my-history-credit.http.payload.dto';

export class MyHistoryCreditHttpMapper {

  static toResponse(data: MyHistoryCreditHttpResponseDto): MyHistoryCreditResponseDto {
    return {
      data: data.data.map((item) => {
        return {
          ...item,
          // status: 13,
          status: Number(item.status),
        }
      })
    }
  }

  static toInfra(data: MyHistoryCreditPayloadDto): MyHistoryCreditHttpPayloadDto {
    return {}
  }

}
